import { UnifiedFile } from ".";

export class NullFile implements UnifiedFile {
  get url() {
    return "";
  }

  upload() {
    return Promise.resolve({ uploadedFile: this });
  }

  get signedId() {
    return "";
  }

  get size() {
    return 0 as const;
  }

  get isNull() {
    return true;
  }

  get value() {
    return null;
  }
}
